import { IPermissionSetGrouping, PermissionSetGroupingKey } from '../../PermissionSetTypes'
import { PermissionType } from '../../PermissionType'
import { DefaultSuperAdminPermissionSet, defaultSuperAdminPermissionSetGrouping } from './DefaultSuperAdminPermissions'
import { SuperAdminOrganizationPermissions } from './SuperAdminPermissions'

export enum EngineeringLeadPermissionSet {
  EngineeringLead = 'super_admin_engineering_lead',
}

export const engineeringLeadPermissionSetGrouping: IPermissionSetGrouping<EngineeringLeadPermissionSet> = {
  key: PermissionSetGroupingKey.SuperAdminEngineeringLead,
  active: {
    [EngineeringLeadPermissionSet.EngineeringLead]: [
      ...defaultSuperAdminPermissionSetGrouping.active[DefaultSuperAdminPermissionSet.DefaultSuperAdmin],
      ...SuperAdminOrganizationPermissions.manageAny,
      PermissionType.POST_SPARE_MOBILE_APP_ORGANIZATION,
      PermissionType.ENABLE_RESTRICTED_FEATURE_FLAGS,
    ],
  },
  unAssignablePermissionSets: [EngineeringLeadPermissionSet.EngineeringLead],
  isSuperAdminSet: true,
}
